import { HTMLAttributes, PropsWithChildren } from 'react';
import { cx } from '@emotion/css';

export const Title = (
  props: PropsWithChildren<HTMLAttributes<HTMLDivElement>> & { extra?: React.ReactNode },
) => {
  const { children, className, extra, ...restProps } = props;
  return (
    <div
      className={cx('mb-4 flex items-center justify-between gap-2 px-4', className)}
      {...restProps}
    >
      <div className="flex items-center gap-2 font-semibold">
        <div className="w-[4px] h-[16px] bg-[#336FFF]" />
        <div>{children}</div>
      </div>
      {extra ? <div>{extra}</div> : null}
    </div>
  );
};
